module.exports = __webpack_public_path__ + "static/img/isolir.89f171e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/isolir.png
// module id = a2iB
// module chunks = 1